// import { Primer } from "@primer-io/checkout-web";
// import { useEffect, useRef } from "react";
// import type { Payment, PrimerCheckout, UniversalCheckoutOptions } from "@primer-io/checkout-web";
// import posthog from "posthog-js";
import greyshield from "@/assets/greyshield.svg";
// import { useModal } from "@/hooks/useModal";
// import { ErrorModal } from "./Modals/ErrorModal";
// import { callFirebaseFunction } from "@/bridge/callFirebaseFunction";
import { ApplePayPage } from "@/pages/ApplePayPage";
// import { StripeIframe } from "./StripeIframe";
// export interface CheckoutContentProps {
//   setPurchaseState: Dispatch<SetStateAction<PurchaseState>>,
// }

import type { ApplePayPageProps } from "@/pages/ApplePayPage";

export function CheckoutContent({ storeListingId, priceId, purchaseId }: ApplePayPageProps) {
  return (
    <div className='mt-14 flex justify-center items-center flex-col'>
      <ApplePayPage storeListingId={storeListingId} priceId={priceId} purchaseId={purchaseId} />
      <span className="flex justify-center w-full font-bold gap-2 items-center text-gray-400 opacity-70 text-xl mt-16">
        <img
          src={greyshield}
          alt="grey shield"
          className="h-4 translate-y-[1px]"
        />
        256-bit SSL secure
      </span>
    </div>
  );
}
